import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import TrendingFinds from "./components/TrendingFinds";
import MiddleCTA from "./components/MiddleCTA";
import ComparisonSection from "./components/ComparisonSection";
import ArticleCards from "./components/ArticleCards";
import GuideSection from "./components/GuideSection";
import TrustSection from "./components/TrustSection";
import FAQSection from "./components/FAQSection";
import SafetySection from "./components/SafetySection";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <TrendingFinds />
        <MiddleCTA />
        <ComparisonSection />
        <ArticleCards />
        <GuideSection />
        <TrustSection />
        <FAQSection />
        <SafetySection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}